import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import NotesModal from './NotesModal'

import { Icon, IconColor, IconName } from 'Components'
import RichTextPanel from 'Components/RichTextPanel/RichTextPanel'
import { JournalNotesRecord } from 'Models'
import { currentJournalDateSelector } from 'ReduxStore/journalDay'
import { dayJournalNotesRecordsSelector, fetchJournalNotesRecordsAction } from 'ReduxStore/journalNotesRecords'

type NotesCardProps = {
  note?: JournalNotesRecord
  onOpen: () => void
}

const NotesCard: React.FC<NotesCardProps> = ({ note, onOpen }) => {
  if (!note || !note.description) {
    return (
      <div className="row g-1">
        <div className="col-12">
          <div className="journalentrypane" onClick={onOpen}>
            <Icon name={IconName.edit} color={IconColor.GRAY_1} />

            <span>Notizen hinzufügen</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <section className="standardcard">
      <div className="standardcard-content px-2 pb-2">
        <div className="standardcard-content standardcard-labelrow my-1">
          <span>Notizen</span>
        </div>

        <div onClick={onOpen}>
          <RichTextPanel className="is-postit" text={note.description} />
        </div>
      </div>
    </section>
  )
}

export const JournalCardNotes: React.FC = () => {
  const dispatch = useDispatch()
  const selectedDate = useSelector(currentJournalDateSelector)
  const notesRecords = useSelector(dayJournalNotesRecordsSelector)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  useEffect(() => {
    dispatch(fetchJournalNotesRecordsAction(selectedDate))
  }, [dispatch, selectedDate])

  const note: JournalNotesRecord | undefined = notesRecords[0]

  const handleOpenModal = (): void => {
    setIsModalOpen(true)
  }

  const handleCloseModal = (): void => {
    setIsModalOpen(false)
  }

  return (
    <>
      <NotesCard note={note} onOpen={handleOpenModal} />

      <NotesModal isOpen={isModalOpen} onClose={handleCloseModal} note={note} />
    </>
  )
}
